<template>
    <div class="cartItem">
        <i :class="removeIcon" @click.prevent="remove"></i><div class="item">{{ item.qty }} Stück(e): {{item.name}}</div>
        <div class="clear"></div>
    </div>
</template>

<script>
export default {

    props: {
        item: {
            required: true
        },
        readonly: {
            default: false
        }
    },

    data() {
        return {
            loading: false,
            removing: false,
            initialized: false,
        }
    },

    methods: {

        remove() {
            this.removing = true;
            new Form({rowId: this.item.rowId})
            .post('/api/cart/remove')
            .then((response) => {
                App.event.fire('cart.updated', response);
                this.removing = false;
            });
        }

    },

    computed: {

        removeIcon() {
            return this.removing ? 'fa fa-spinner' : 'icon-remove';
        }

    }


}
</script>

